import { render, staticRenderFns } from "./PoolDetailsTab.vue?vue&type=template&id=32188ee9&scoped=true&"
import script from "./PoolDetailsTab.vue?vue&type=script&lang=js&"
export * from "./PoolDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32188ee9",
  null
  
)

export default component.exports